<template lang="pug">
#IndicarRMA
  b-button(
    variant="action"
    @click="showRMAModal()"
    :disabled="disabled"
  )
    | {{ title }}
  b-modal(
    v-model="showModal"
    centered
    :title="'Indicar RMA OV: ' + dataOv.id"
  )
    b-form-group.mb-4(
      label="RMA"
      label-for="rma"
    )
      b-form-input(
        id="rma"
        :state="$v.rma.$dirty ? !$v.rma.$error : null"
        v-model="rma"
        maxlength="10"
        placeholder="Ingrese RMA (10 carácteres)"
      )
      b-form-invalid-feedback(
        v-if="$v.rma.$dirty && !$v.rma.minLength"
      ) Debe ser de 10 caracteres
      b-form-invalid-feedback(
        v-if="$v.rma.$dirty && !$v.rma.required"
      ) Campo requerido

      b-alert(v-if="statusRMA" show variant="danger" class="mt-2 small") RMA ya se encuentra registrado

    template(#modal-footer='{ ok, cancel, hide }')
      .d-flex.justify-content-between(style='width: 100%')
        b-button(size='sm' variant='secondary' @click='hideModal' :disabled="loading") Cancelar
        b-button(size='sm' variant='primary' @click='saveRMA' :disabled="loading || statusRMA") Aceptar
          b-spinner(v-if="loading" small)
</template>
<script>
import { mapActions } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'IndicarRMA',
  props: {
    dataOv: { type: Object, required: true },
    actionCondition: { type: String, default: 'IndicarRMA' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      showModal: false,
      loading: false,
      rma: '',
      statusRMA: false,
    }
  },
  validations: {
    rma: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    }
  },
  computed: {
    title() {
      const title = this.actionCondition.replace(/([a-z])([A-Z])/g, '$1 $2');
      return title;
    }
  },
  methods: {
    ...mapActions('OVStore', ['setRMA', 'validateRMA']),
    showRMAModal() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    saveRMA() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.loading = true;
      this.setRMA({
        id_oportunidad_venta: this.dataOv.id,
        rma: this.rma,
        change_state: !!this.actionCondition === 'IngresarRMA'
      }).then(() => {
        this.$emit('reloadAll');
        this.loading = false;
        this.hideModal();
      }).catch((e) => {
        console.error(e)
        this.$bvToast.toast('Error al guardar RMA', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }).finally(() => {
        this.loading = false;
      });
    },
    async validateExistRMA(rma) {
      try {
        const response = await this.validateRMA(rma);
        if(!response.data.status){
          this.statusRMA = true;
        }
      } catch (error) {
        this.statusRMA = true;
      }
    }
  },
  watch: {
    rma(newValue){
      if(newValue.length === 10){
        this.validateExistRMA(newValue)
      } else {
        this.statusRMA = false
      }
    }
  }
}
</script>
